<template>
  <div>
    <router-view class="mainLayout" :key="$route.fullPath"></router-view>
    <div class="cookieWrap" v-if="isCookieAlertOpen">
      <div class="cookieBox">
        <div class="cookieTitle">{{ $t('cookies.title') }}</div>
        <p>
          {{ $t('cookies.description') }}
          <router-link :to="{ name: 'Cookie'}">{{ $t('cookies.cookiesLink') }}</router-link>{{ $t('cookies.and') }}
          <router-link :to="{ name: 'Privacy'}">{{ $t('cookies.privacyLink') }}</router-link>。
        </p>
        <a @click="closeCookieAlert" class="close">{{ $t('cookies.close') }}</a>
      </div>
    </div>
  </div>

</template>
<script>
import { mapActions } from 'vuex'
import TRACKER_LOG_INTERVAL from '../../config'

export default {
  data() {
    return {
      isCookieAlertOpen: true,
      trackerLogTimer: null,
    }
  },
  created() {
    this.checkIsCookieAlertOpen()
  },
  async mounted() {
    await this.initFootPrint()
    this.setTrackerLogTimer()
  },
  beforeDestroy() {
    clearInterval(this.trackerLogTimer)
    this.trackerLogTimer = null
  },
  watch: {
    $route() {
      this.checkIsCookieAlertOpen()
    },
  },
  methods: {
    ...mapActions([
      'initFootPrint',
      'trackerLog',
    ]),
    checkIsCookieAlertOpen() {
      const storageIsCookieAlertOpen = localStorage.getItem('isCookieAlertOpen', false)
      if (!storageIsCookieAlertOpen) this.isCookieAlertOpen = true
      if (storageIsCookieAlertOpen && storageIsCookieAlertOpen !== 'false') this.isCookieAlertOpen = true
      if (storageIsCookieAlertOpen && storageIsCookieAlertOpen === 'false') this.isCookieAlertOpen = false
    },
    closeCookieAlert() {
      this.isCookieAlertOpen = false
      localStorage.setItem('isCookieAlertOpen', false)
    },
    setTrackerLogTimer() {
      this.trackerLogTimer = setInterval(() => {
        const projectCode = localStorage.getItem('projectCode') || undefined
        const projectInfo = localStorage.getItem('projectInfo') ? JSON.parse(localStorage.getItem('projectInfo')) : null
        this.trackerLog({
          event: 'interval_log',
          message: {
            exhibitionId: projectCode,
            exhibition: projectInfo ? projectInfo.showLocalName : undefined,
          },
        })
      }, TRACKER_LOG_INTERVAL)
    },
  },
}
</script>
<style>

</style>
